import { Component } from '@angular/core';
import { Links } from './links';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service'
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';

@Component({
    template: require('./foc-requests.component.html'),
    styles: [require('./foc-requests.component.scss')]
})

export class FOCRequestsComponent 
{
    data:any = [];
    dialogRef;
    id:any;
    navLinks = [
            new Links('1','create',"add_user_info",'create/'),
            new Links('2','FOC','FOC item details','return/'),
            new Links('3','Confirm details','Confirm all details','confirm/')
        ];
    userData:any;
    orderId:any;
    isApprover:boolean = false;
    constructor(private router: Router,private commonService : CommonService,private route: ActivatedRoute,private sessionHandler:SessionHandler,
    private http:HttpService,private dialog: MdDialog) {
        
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.commonService.viewData.subscribe((value) => {
            this.data = value;
            this.setlinks(this.data);
            });
        }

        public setlinks(data){
            if(data && data.orderId){
                this.orderId = data.orderId;
                this.navLinks = [
                    new Links('1','create',"add_user_info",'create/'+data.orderId),
                    new Links('2','FOC','FOC item details','return/'+data.orderId),
                    new Links('3','Confirm Details','Confirm all details','confirm/'+data.orderId)
                ];
                // if(this.userData.role && this.userData.role.length > 0){
                //     for(let u in this.userData.role){
                //         if(this.userData.role[u] == 'APPROVER') {
                //             this.isApprover = true;
                //         }
                //     }
                // }
            }
        }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt-foc/foc-requests.component.ts